var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"leaderboard-chart"},[_c('canvas',{ref:"npsgrid",class:{ hidden: _vm.hideCanvas }}),_c('Loading',{attrs:{"loading":!_vm.chartRendered || !!_vm.tsLoadingTeamGroupSummary}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }